<template>
  <div id="app">
    <router-view />
    <Modal />
    <LoadingOverlay />
    <vue-confirm-dialog class></vue-confirm-dialog>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import LoadingOverlay from "@/components/LoadingOverlay";
// test
export default {
  name: "FisherMeetings",
  components: {
    Modal,
    LoadingOverlay
  },
};
</script>
<style lang="scss" src="@/styles/style-app.scss">
